import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	zAxisOptions: {
		id: 'polaris-ideas.right-sidebar.matrix-axis.z-axis.z-axis-options',
		defaultMessage: 'Size',
		description: 'Header label for matrix z-axis',
	},
});
